import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ErrorDetailsDialog } from 'app/components/composite/ErrorDetailsDialog';

export function NotificationDetails({ message = null, onClose }) {
    const { t } = useTranslation();
    return (
        <ErrorDetailsDialog
            title={t('components:NotificationHub.detailsTitle')}
            message={message}
            onClose={onClose}
        />
    );
}

NotificationDetails.propTypes = {
    onClose: PropTypes.func.isRequired,
    message: PropTypes.string
};
